export const YANDEX_METRIKA_CODE = 55070392;
